<template>
  <div class="mathinelist" v-if="mathineList?.length > 0">
    <div class="item" :class="{ 
      running: item?.status == 2, 
      error: item?.status == 3, 
      disabled: item?.status == 1,
      selected: item?.id == curTab?.id
    }" v-for="(item, index) in mathineList" @click="tabHandle(item)">
      <em />
      <el-tooltip effect="light" :content="CONST.MATHINE_STATUS_LABEL[item?.status]" placement="top">
        <span>{{item?.name}}</span>
      </el-tooltip>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import * as Request from '@/assets/request';
  import * as CONST from '@/assets/const';

  const emits = defineEmits([ 'change' ])

  // 机器列表
  const mathineList = ref([])
  const getMachines = async () => {
    const result = await Request.post({
      url: '/22001/facade/dispatch/machines'
    });
    if(result?.code != 200) return;

    if(result?.data?.length > 0) {
      mathineList.value = result?.data;
    }
  }
  onMounted(() => {
    getMachines()
  })

  const curTab = ref(null)
  const tabHandle = item => {
    curTab.value = item;
    emits('change', item);
  }
</script>

<style scoped lang="less">
@import "./index.less";
</style>
